import React from "react";
import { Chart } from "react-google-charts";
import Spinner from "../../../spinner/spinner";

export default function ProductivityChart({ loading, data, showChart }) {

    const options = {
        colors: ['#0000cc', '#990000'],
        title: "Productivity",
        fontSize: 15,
        chartArea: { width: "50%" },
        hAxis: {
            title: "Job",
            titleTextStyle: {
                color: '#333',
                bold: true,
                fontSize: 15
            },
            textStyle: {
                color: '#333'
            },
        },
        vAxis: {
            title: "Count",
            baselineColor: "#000000",
            titleTextStyle: {
                color: '#333',
                bold: true,
                fontSize: 15
            },
            textStyle: {
                color: '#333'
            },
        },
    };

    return (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
            {loading ? (
                <Spinner />
            ) : (
                <React.Fragment>
                    {showChart ? (
                        data.length > 1 ? (
                            <Chart
                                chartType="ColumnChart"
                                style={{ marginTop: "20px", marginBottom: "20px", width: "100%", height: "400px" }}
                                width="100%"
                                height="400px"
                                data={data}
                                options={options}
                            />
                        ) : (
                            <h3>No Data Available</h3>
                        )
                    ) : null}
                </React.Fragment>
            )}
        </div>
    )
}